import { Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinner }        from '@angular/material/progress-spinner';
import { ActivatedRoute, Router }    from '@angular/router';

import { HttpStatusCode }       from '../../../core/error-handling/http-status-codes';
import { environment }          from '../../../../environments/environment';
import { RestService }          from '../../../core/rest.service';
import { errorMessageList }     from '../../../core/error-handling/app-error-handler';
import { ButtonComponent }      from '../../../shared/components/buttons/button.component';
import { CardComponent }        from '../../../shared/components/card/card.component';
import { CardContentComponent } from '../../../shared/components/card/content/card-content.component';
import { FooterComponent }      from '../../../shared/components/footer/footer.component';
import { NewHeaderComponent }   from '../../../shared/components/new-header/new-header.component';
import { ComponentType }        from '../../../shared/components/components.utils';

@Component({
  selector: 'pin-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [ButtonComponent, CardComponent, CardContentComponent, MatProgressSpinner, FooterComponent, NewHeaderComponent]
})
export class ErrorComponent implements OnInit {
  statusCodeEnum = HttpStatusCode;
  errorCode: number;
  isLoading = false;
  backEndConnection = "FAILURE";
  userAgent = navigator.userAgent;
  displayCard = false;
  errorDetailsSeen = false;
  showTooltip = false;
  protected readonly errorMessageList = errorMessageList;
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private restService = inject(RestService);

  ngOnInit() {
    const codePathVar = this.route.snapshot.paramMap.get('code');
    this.errorCode = codePathVar ? Number(codePathVar) : this.route.snapshot.data.code;

    if (Number.isNaN(this.errorCode)) {
      this.router.navigate(['error']);
    }
  }

  redirectToMainPage() {
    window.location.href = this.router.createUrlTree(['/']).toString();
  }

  checkBackendConnection() {
    this.restService.get(environment.api.endpoints.failoverStatusCheck)
      .subscribe(() => {
        this.backEndConnection = "SUCCESS";
      })
  }

  showConsoleDetails() {
    if (!this.errorDetailsSeen) {
      this.checkBackendConnection();
      this.errorDetailsSeen = true;
    } else {
      this.showTooltip = false;
    }
    this.displayCard = !this.displayCard;
  }

  copyDisplayedInformation() {
    let cardErrorMessage = "";
    this.errorMessageList.forEach(errorMessage => cardErrorMessage += errorMessage + "\n");
    const text = "user agent: " + this.userAgent + "\nback-end connection: " + this.backEndConnection + "\nbrowser errors: " + cardErrorMessage;
    const type = "text/plain";
    const blob = new Blob([text], {type});
    const data = [new ClipboardItem({[type]: blob})]
    navigator.clipboard.write(data)

    this.showTooltip = true;
    setTimeout(() => {
      this.showTooltip = false;
    }, 3000)
  }

  protected readonly logoType = ComponentType;
}
